import React, {useState} from "react";
import {Checkbox, Form, FormInstance, Space} from "antd";
import {Checkbox as MobileCheckbox, Form as MobileForm} from 'antd-mobile';
import cx from "classnames";
import {CheckboxValueType} from "antd/es/checkbox/Group";
import {RightOutlined} from "@ant-design/icons";
import {FormInstance as MobileFormInstance} from "antd-mobile/es/components/form/form";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import styles from "@/page-components/detail/Intro/styles.module.less";

type TShouldPass = {
  form?: FormInstance;
  mobileFormInstance?: MobileFormInstance;
  isPassStudentAuthentication: boolean;
  passNum: number;
  onChange: (checkValue: CheckboxValueType[]) => void;
  data: {
    id: string,
    label: string;
    value: string,
    price: number;
    isPass?: boolean;
    student_price?: number
  }[],
}

const ShouldPass: React.FC<TShouldPass> = ({
                                             onChange,
                                             mobileFormInstance,
                                             form,
                                             passNum,
                                             data,
                                             isPassStudentAuthentication
                                           }) => {
  const [value, setValue] = useState<CheckboxValueType[]>([]);
  const renderPrice = (price: number, student_price?: number, isPass?: boolean) => {
    if (isPass) {
      return 0;
    }
    if (student_price && isPassStudentAuthentication) {
      return student_price;
    }
    return price;
  }
  const renderTips = (student_price?: number, isPass?: boolean) => {
    if (isPass) {
      return <span className={styles.exam_pass_opt_grey_text}>考试已通过，无需付费</span>
    }
    if (student_price) {
      if (isPassStudentAuthentication) {
        return <span className={styles.exam_pass_opt_grey_text}>享受学生优惠价</span>
      }
      return (
        <a href="https://fanruanclub.com/?tab=auth&type=student">
          <Space className={cx(styles.exam_pass_opt_text, styles.exam_pass_opt_student_price)}>
            <span>{`学生认证后${student_price}元`}</span>
            <RightOutlined/>
          </Space>
        </a>
      )
    }
    return '';
  }
  return (
    <>
      <PcComponentWrapper>
        <Form.Item
          className={cx(styles.row, styles.row_gap)}
          name="should_choose"
          valuePropName="checked"
          label={<span className={styles.tips_text} style={{width: 'auto'}}>选考项目</span>}
          rules={[
            {
              validator(_, fieldValue) {
                console.log('验证');
                console.log(value);
                if (!value || value.length > passNum) {
                  return Promise.reject(new Error(`请选择${passNum}个考试项目`));
                }
                return Promise.resolve();
              },
            }, {required: true, message: '请选择选考项目'}]}
        >
          <div className={styles.bold_text}>通过以下{data.length}中任意{passNum}个</div>
          <Checkbox.Group
            style={{width: '100%'}}
            onChange={(res) => {
              console.log('res');
              setValue(res);
              if (form) {
                form.setFieldsValue({should_choose: res});
              }
              if (mobileFormInstance) {
                mobileFormInstance.setFieldsValue({should_choose: res});
              }
              onChange(res);
            }}
          >
            <Space size={10} direction="vertical" style={{width: '100%'}}>
              {data.map(item => {
                return (
                  <div key={item.id} className={cx(styles.exam_pass_opt, value.includes(item.value) && styles.active)}>
                    <Space>
                      <Checkbox value={item.value}/>
                      <div>
                        <p className={styles.exam_pass_opt_should_label}>{item.label}</p>
                        <Space>
                          <span
                            className={cx(styles.exam_pass_opt_text, styles.exam_pass_opt_price)}>￥{item.isPass ? 0 : item.price}</span>
                          {renderTips(item.student_price, item.isPass)}
                        </Space>
                      </div>
                    </Space>
                  </div>
                )
              })}
            </Space>
          </Checkbox.Group>
        </Form.Item>
      </PcComponentWrapper>
      <MobileComponentWrapper>
        <MobileForm.Item
          className={cx(styles.row, styles.row_gap)}
          name="should_choose"
          valuePropName="checked"
          label={<span className={styles.tips_text}>选考项目</span>}
          rules={[
            {
              validator(_, fieldValue) {
                console.log('验证');
                console.log(value);
                if (!value || value.length > passNum) {
                  return Promise.reject(new Error(`请选择${passNum}个考试项目`));
                }
                return Promise.resolve();
              },
            }, {required: true, message: '请选择选考项目'}]}
        >
          <MobileCheckbox.Group
            onChange={(res) => {
              console.log('res');
              setValue(res);
              if (form) {
                form.setFieldsValue({should_choose: res});
              }
              if (mobileFormInstance) {
                mobileFormInstance.setFieldsValue({should_choose: res});
              }
              onChange(res);
            }}
          >
            <Space size={12} direction="vertical" style={{width: 'calc(100vw - 32px)'}}>
              {data.map(item => {
                return (
                  <div key={item.id} className={cx(styles.exam_pass_opt, value.includes(item.value) && styles.active)}>
                    <Space>
                      <MobileCheckbox value={item.value}/>
                      <div>
                        <p className={styles.exam_pass_opt_should_label}>{item.label}</p>
                        <Space>
                          <span
                            className={cx(styles.exam_pass_opt_text, styles.exam_pass_opt_price)}>￥{renderPrice(item.price,item.student_price, item.isPass)}</span>
                          {renderTips(item.student_price, item.isPass)}
                        </Space>
                      </div>
                    </Space>
                  </div>
                )
              })}
            </Space>
          </MobileCheckbox.Group>
        </MobileForm.Item>
      </MobileComponentWrapper>
    </>
  )
}
export default ShouldPass;
